import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styled, { css } from 'styled-components/macro';
import { faTimes, faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import Modal from 'src/components/Modal';
import { NumericInput } from '../../components/Input';
import {
  Cell, Icon, Label,
} from '../../components/Layout';
import { colorTypes, getBrandingColor } from '../../branding';
import {
  animalKindToNorwegian,
  AnimalRowAddComment,
  CheckmarkLabel,
  CheckmarkText,
  Completed,
  DropdownElem, Errors, getErrorsTotAmountAnimalsInHealthRemarksGroup, getHasHealthRemarksWithRequiredComments, getHasRequiredCommentsForHealthRemarks, getReturnSheep, HoverRow, InputError, LabelContainer, ModalCancelButton, ModalDangerousActionButton,
} from './Components';
import Button from '../../components/Button';
import { SearchableDropdown } from '../../components/SearchableDropdown';
import { healthRemarks, healthRemarksIdsRequiresComment, maxLengthHealthRemarksComment } from './Config';
import {
  capitalize, flatArray, float, groupObjectsByKey, int,
} from '../../utils/misc.utils';
import { NotCompleted } from '../Profile/ChangePassword';

const Header = styled.h2`
  white-space: nowrap;
@media screen and (max-width: 500px) {
  white-space: normal;
}
`;
const NoticeContent = styled.div`
padding: 0.6em;
`;
const NoticeWrapper = styled.div`
  display: flex;
  margin-top: 1.1em;
  border: 2px solid #DEDDDB;
  border-radius: 4px;
`;
const HeaderDetail = styled.span`
font-size: 0.82em;
margin-left: 0.2em;
@media screen and (max-width: 500px) {
  display: block; /* break into own line */
}
`;
const NoticeMark = styled.div`
  width: 6px;
  border-bottom-left-radius: 2.5px;
    border-top-left-radius: 2.5px;
  background-color: ${({ kind }) => ({ warning: '#EA780E', success: ' #008243' }[kind])};
`;

const NoticeIcon = styled(FontAwesomeIcon)`
  align-self: center;
  margin-left: 1rem;
  font-size: 1.5rem;
`;

const Notice = ({ children, kind, ...props }) => (
  <NoticeWrapper {...props}>
    <NoticeMark kind={kind} />
    <NoticeIcon icon={kind === 'success' ? faCheckCircle : faExclamationCircle} />
    <NoticeContent>
      {children}
    </NoticeContent>
  </NoticeWrapper>
);
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    max-width: 441px;
    margin-top: 0.5rem;
}
`;
const GroupWrapper = styled.div`
  margin-bottom: 2rem;
`;

const HealthRemarksIndividualAnimals = ({
  animals, header, animalKind, onChangeComment, onChangeHealthRemark, allAnimals, selectedAnimalGroup,
}) => (
  <>
    <Header>{header}</Header>
    {animals.map((a) => {
      const animalRowIdx = allAnimals.findIndex((aa) => ((selectedAnimalGroup === 'pigs' && a.ear_tag === aa.ear_tag) || (selectedAnimalGroup === 'cattle' && `${a.mark_no}/${a.individual_no}` === `${aa.mark_no}/${aa.individual_no}`) || (selectedAnimalGroup === 'sheep' && aa.subcategory_name === a.subcategory_name)));
      const returnSheepIdx = selectedAnimalGroup === 'sheep' && allAnimals.find((aa) => aa.subcategory_name === a.subcategory_name).return_sheep.findIndex((aa) => aa.individual_no === a.individual_no);
      return (
        <>
          <p>
            {animalKind === 'pigs'
      && `Øremerke: ${a.ear_tag}`}
            {animalKind === 'cattle'
        && `Merke/Individnr: ${a.mark_no}/${a.individual_no}` }
            {animalKind === 'sheep' && `Individnr: ${a.individual_no}`}
          </p>
          <SearchableDropdown
            placeholder="Søk etter helseavvik"
            itemSearchKey="text"
            smallScreenwidth="100%"
            bigScreenWidth="435px"
            dropdownStyle={{ maxWidth: '85vw' }}
            bigScreenWidthResultList="435px"
            smallScreenWidthResultList="100%"
            selectedItem={healthRemarks.find((hr) => hr.id === a.health_remarks_code) || null}
            renderSelectedItemInInput={(selected) => selected && selected.text}
            initialValue="Trykk for å velge helseavvik"
            renderItem={(item, searchTerm, itemHasFocus, itemIsChoosed) => (
              <DropdownElem
                itemIsChoosed={itemIsChoosed}
                searchTerm={capitalize(searchTerm)}
                itemHasFocus={itemHasFocus}
                item={{ ...item, text: capitalize(item.text) }}
                disableHighlightMatchOnSearch
              />
            )}
            dataitems={healthRemarks || []}
            onSelectedChange={(item) => item && onChangeHealthRemark({
              remark: item, animalRowIdx, isReturnSheep: selectedAnimalGroup === 'sheep', returnSheepIdx, isIndividual: true,
            })}
          />

          <HealthRemarkComment
            isAnimalInGroup={false}
            comment={a.health_remarks_comment}
            onChangeComment={(comment) => onChangeComment({
              comment, animalRowIdx, isIndividual: true, isReturnSheep: selectedAnimalGroup === 'sheep', returnSheepIdx,
            })}
          />

        </>
      );
    })}

  </>
);

export const getAmountAnimalsInGroupWithoutHealthRemarkGroup = (animalRow) => {
  if (!animalRow.health_remarks_groups) {
    return animalRow.health_remarks_cnt;
  }

  let totAmount = parseInt(animalRow.health_remarks_cnt, 10);
  (animalRow.health_remarks_groups || []).map((remarkGroup) => {
    if (remarkGroup.amount_animals) {
      totAmount -= parseInt(remarkGroup.amount_animals, 10);
    }
  });

  return totAmount;
};

export const HealthRemarkComment = ({ comment, onChangeComment, isAnimalInGroup }) => (
  <div>
    <AnimalRowAddComment
      placeholder={`Skriv en kommentar om ${isAnimalInGroup ? 'dyrene' : 'dyret'} har helseavvik og hvordan ${isAnimalInGroup ? 'dyrene' : 'dyret'} er merket. Har ${isAnimalInGroup ? 'dyrene' : 'dyret'} sekundær-avvik skal disse føres opp her. ${isAnimalInGroup ? 'Før også opp dyrenes individnummer.' : ''}`}
      value={comment || ''}
      onChange={(evt) => onChangeComment(evt.target.value)}
      leftAlign
      style={{ height: isAnimalInGroup ? '123px' : '102px' }}
    />
    <Label
      style={{
        textAlign: 'center',
        color:
                    comment && comment.length > maxLengthHealthRemarksComment
                      ? getBrandingColor(colorTypes.error)
                      : '#4a4a4a',
      }}
    >
      {`${comment ? comment.length : 0} av ${maxLengthHealthRemarksComment} tegn`}
    </Label>
  </div>
);

// If the user has checked for "has health remarks" when adding the animals for the enrollment,
// the user has to specifiy which health remarks the animals has

// for individual animals: purke/råne(if these are to be enrolled individually by config), cattle or sheep marked for return
// the user specifies a health remark per animal

// for animals in groups(all animals not individual): the user distributes the animals into health remark groups,
// uintill all animals in the group has a health remark group
// the animals in each animal group cannot be mixed into different remark groups, its a 1-to-1 with animal group and
// health remark groups
export const SpecifyHealthRemarks = ({
  animalRows,
  selectedAnimalGroup,
  onChangeAmountAnimalsInGroup,
  onAddHealthRemarksGroup,
  onDeleteHealthRemarkGroup,
  onChangeHealthRemark,
  onChangeComment,
}) => {
  const [healthRemarkGroupToDelete, setHealthRemarkGroupToDelete] = useState(null);
  const animalRowsWithHealthRemarks = animalRows.filter((a) => a.health_remarks_cnt || a.has_health_remarks || (a.return_sheep && getReturnSheep(a).find((a) => a.has_health_remarks)));

  let animalsEnrolledInGroups = [];
  if (selectedAnimalGroup === 'pigs') {
    animalsEnrolledInGroups = animalRowsWithHealthRemarks.filter((a) => a.club_no);
  } else if (selectedAnimalGroup === 'sheep') {
    animalsEnrolledInGroups = animalRowsWithHealthRemarks.filter((a) => !a.return_sheep || (a.has_health_remarks && parseInt(a.amount, 10) > a.return_sheep.length));
  } else if (selectedAnimalGroup === 'cattle') {
    animalsEnrolledInGroups = []; // cattle is always individually
  }

  let animalsEnrolledIndividually = [];
  if (selectedAnimalGroup === 'pigs') {
    animalsEnrolledIndividually = animalRowsWithHealthRemarks.filter((a) => !a.club_no);
  } else if (selectedAnimalGroup === 'cattle') {
    animalsEnrolledIndividually = animalRowsWithHealthRemarks;
  } else if (selectedAnimalGroup === 'sheep') {
    animalsEnrolledIndividually = flatArray(animalRowsWithHealthRemarks.map((a) => a.return_sheep.filter((rs) => rs.has_health_remarks)));
  }

  const purkeEnrolledIndividually = animalsEnrolledIndividually.filter((a) => a.subcategory_name === 'Purke');
  const raaneEnrolledIndividually = animalsEnrolledIndividually.filter((a) => a.subcategory_name === 'Råne');
  const otherAnimalsEnrolledIndividually = animalsEnrolledIndividually.filter((a) => !['Purke', 'Råne'].includes(a.subcategory_name));

  const getAllAnimalsHasHealthRemarks = (animals) => animals.every((a) => {
    if (a.health_remarks_groups?.length > 0) {
      if (!a.health_remarks_groups.every((g) => g.health_remarks_code)) {
        return false;
      }
    } else if (a.has_health_remarks || a.health_remarks_cnt) {
      if (!a.health_remarks_code) {
        return false;
      }
    }
    if (getReturnSheep(a).length > 0) {
      if (!getReturnSheep(a).every((rs) => !rs.has_health_remarks || rs.health_remarks_code)) {
        return false;
      }
    }
    return true;
  });
  const allHealthRemarksGroupsHasHealthRemarks = getAllAnimalsHasHealthRemarks(animalRowsWithHealthRemarks);
  const allAnimalsIsInHealthRemarksGroup = animalsEnrolledInGroups.length === 0 || animalsEnrolledInGroups.every((a) => getAmountAnimalsInGroupWithoutHealthRemarkGroup(a) === 0);
  const hasHealthRemarksWithRequiredComment = getHasHealthRemarksWithRequiredComments(animalRowsWithHealthRemarks);
  const allHealthRemarksWithRequiredCommentsHasComment = getHasRequiredCommentsForHealthRemarks(animalRows, selectedAnimalGroup);

  const getErrorForAmountAnimalsInHealthRemarkGroup = (amount) => {
    if (amount && (Number.isNaN(int(amount))
          || int(amount) < 0
          || int(amount) === 0
          || float(amount) % 1 !== 0)) {
      return 'Ugyldig antall';
    }
    return null;
  };

  const onAskDeleteHealthRemarkGroup = (animalGroupIdx, healthRemarkGroupIdx) => {
    setHealthRemarkGroupToDelete({ animalGroupIdx, healthRemarkGroupIdx });
  };

  return (
    <Wrapper>
      {purkeEnrolledIndividually.length > 0
        && (
          <HealthRemarksIndividualAnimals
            animals={purkeEnrolledIndividually}
            header={`${purkeEnrolledIndividually.length} Purke med helseavvik`}
            animalKind="pigs"
            onChangeComment={onChangeComment}
            onChangeHealthRemark={onChangeHealthRemark}
            allAnimals={animalRows}
            selectedAnimalGroup={selectedAnimalGroup}
          />
        )}

      {raaneEnrolledIndividually.length > 0
      && (
        <HealthRemarksIndividualAnimals
          animals={raaneEnrolledIndividually}
          header={`${raaneEnrolledIndividually.length} Råne med helseavvik`}
          animalKind="pigs"
          onChangeComment={onChangeComment}
          onChangeHealthRemark={onChangeHealthRemark}
          allAnimals={animalRows}
          selectedAnimalGroup={selectedAnimalGroup}
        />
      )}

      {otherAnimalsEnrolledIndividually.length > 0
      && (
        <HealthRemarksIndividualAnimals
          animals={otherAnimalsEnrolledIndividually}
          header={`${otherAnimalsEnrolledIndividually.length} individuelle ${animalKindToNorwegian(selectedAnimalGroup)} med helseavvik`}
          animalKind={selectedAnimalGroup}
          onChangeComment={onChangeComment}
          onChangeHealthRemark={onChangeHealthRemark}
          allAnimals={animalRows}
          selectedAnimalGroup={selectedAnimalGroup}
        />
      )}

      {animalsEnrolledInGroups.map((animalGroup) => {
        const cntAnimalsWithoutRemarkGroup = getAmountAnimalsInGroupWithoutHealthRemarkGroup(animalGroup);
        const animalRowIdx = animalRows.findIndex((ar) => (selectedAnimalGroup === 'pigs' && ar.club_no === animalGroup.club_no)
          || (selectedAnimalGroup === 'sheep' && ar.subcategory_name === animalGroup.subcategory_name));

        const cntRemarkGroups = (animalGroup.health_remarks_groups || []).length;
        return (
          <div>
            <Header>
              {animalGroup.health_remarks_cnt}
              {' '}
              {animalGroup.subcategory_name}
              {' '}
              med helseavvik
              {selectedAnimalGroup === 'pigs'
            && (
              <HeaderDetail>
                (Klubbenummer:
                {animalGroup.club_no}
                ).
              </HeaderDetail>
            ) || '.'}
            </Header>

            {(animalGroup.health_remarks_groups || []).map((healtRemarkGroup, healthRemarkGroupIdx) => (
              <GroupWrapper>
                <Label
                  color={getBrandingColor(colorTypes.primary)}
                  marginBottom="-0.3em"
                >
                  Antall i gruppa:
                </Label>
                <div
                  style={{
                    position: 'relative',
                  }}
                >
                  <NumericInput
                    min="0"
                    value={healtRemarkGroup.amount_animals || ''}
                    onChange={(evt) => onChangeAmountAnimalsInGroup({ amount: evt.target.value, animalRowIdx, healthRemarkGroupIdx })}
                    error={getErrorForAmountAnimalsInHealthRemarkGroup(healtRemarkGroup.amount_animals)}
                  />

                  {getErrorForAmountAnimalsInHealthRemarkGroup(healtRemarkGroup.amount_animals) && (
                    <InputError
                      message={getErrorForAmountAnimalsInHealthRemarkGroup(healtRemarkGroup.amount_animals)}
                      style={{ top: '7px' }}
                    />
                  )}
                </div>

                <SearchableDropdown
                  placeholder="Søk etter helseavvik"
                  itemSearchKey="text"
                  smallScreenwidth="100%"
                  bigScreenWidth="435px"
                  dropdownStyle={{ maxWidth: '85vw' }}
                  bigScreenWidthResultList="435px"
                  smallScreenWidthResultList="100%"
                  selectedItem={healthRemarks.find((hr) => hr.id === healtRemarkGroup.health_remarks_code) || null}
                  renderSelectedItemInInput={(selected) => selected && selected.text}
                  initialValue="Trykk for å velge helseavvik"
                  renderItem={(item, searchTerm, itemHasFocus, itemIsChoosed) => (
                    <DropdownElem
                      itemIsChoosed={itemIsChoosed}
                      searchTerm={capitalize(searchTerm)}
                      itemHasFocus={itemHasFocus}
                      item={{ ...item, text: capitalize(item.text) }}
                      disableHighlightMatchOnSearch
                      wrapText
                    />
                  )}
                  dataitems={healthRemarks || []}
                  onSelectedChange={(item) => item && onChangeHealthRemark({ remark: item, animalRowIdx, healthRemarkGroupIdx })}
                />

                <HealthRemarkComment
                  comment={healtRemarkGroup.health_remarks_comment}
                  isAnimalInGroup
                  onChangeComment={(comment) => onChangeComment({ comment, animalRowIdx, healthRemarkGroupIdx })}
                />

                <HoverRow
                  onClick={() => onAskDeleteHealthRemarkGroup(animalRowIdx, healthRemarkGroupIdx)}
                  style={{
                    fontSize: '0.85rem',
                    color: getBrandingColor(colorTypes.primary),
                  }}
                >
                  <Icon
                    size="1.4em"
                    marginRight="0.4em"
                    icon={faTimes}
                    style={{ marginLeft: 'auto' }}
                  />
                  <Label
                    textDecoration="underline"
                    role="button"
                  >
                    Slett gruppe
                  </Label>
                </HoverRow>
              </GroupWrapper>
            ))}

            {getErrorsTotAmountAnimalsInHealthRemarksGroup(animalGroup) && (
              <Errors
                errors={getErrorsTotAmountAnimalsInHealthRemarksGroup(animalGroup)}
                variants={
                {
                  visible: {
                    maxHeight: '150px',
                    transition: { maxHeight: { duration: 0.3 }, maxWidth: { duration: 0 } },
                    maxWidth: '430px',
                  },
                  collapsed: {
                    maxHeight: 0,
                    overflow: 'hidden',
                  },
                }
              }
              />
            )}

            {cntAnimalsWithoutRemarkGroup > 0
            && (
              <Button
                primary
                onClick={() => onAddHealthRemarksGroup(animalRowIdx)}
                style={{
                  position: 'relative',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  marginTop: '0',
                }}
              >
                <Cell padding="0.1em 0em">
                  <Label bold size="1.2em">
                    Legg til ny gruppe for helseavvik
                  </Label>
                </Cell>
              </Button>
            )}

            {cntRemarkGroups > 0 && cntAnimalsWithoutRemarkGroup > 0 && (
              <Notice kind="warning">
                {cntAnimalsWithoutRemarkGroup}
                {' '}
                {animalGroup.subcategory_name}
                {' '}
                med helseavvik ikke fordelt i gruppe
              </Notice>
            )}

          </div>
        );
      })}

      <Notice kind={allAnimalsIsInHealthRemarksGroup && allHealthRemarksGroupsHasHealthRemarks && (!hasHealthRemarksWithRequiredComment || allHealthRemarksWithRequiredCommentsHasComment) ? 'success' : 'warning'} style={{ marginTop: '2.5em' }}>
        <Label>Krav:</Label>

        {animalsEnrolledInGroups.length > 0
        && (
          <CheckmarkLabel>
            { (allAnimalsIsInHealthRemarksGroup && <Completed />) || <NotCompleted />}
            <CheckmarkText>
              Alle dyr
              {' '}
              {animalsEnrolledIndividually.length > 0 && ' i gruppe '}
              {' '}
              er fordelt i en helseavvik-gruppe
            </CheckmarkText>
          </CheckmarkLabel>
        )}
        <CheckmarkLabel>
          { (allHealthRemarksGroupsHasHealthRemarks && <Completed />) || <NotCompleted />}
          <CheckmarkText>
            {(animalsEnrolledInGroups.length === 0
            && 'Alle dyr ovenfor har fått et helseavvik')
            || `Alle helseavvik-grupper ${animalsEnrolledIndividually.length > 0 ? ' og individuelle dyr ovenfor' : ''} har fått et helseavvik`}
          </CheckmarkText>

        </CheckmarkLabel>
        {hasHealthRemarksWithRequiredComment
        && (
          <CheckmarkLabel>
            {(allHealthRemarksWithRequiredCommentsHasComment && <Completed />) || <NotCompleted />}
            <CheckmarkText>
              Alle helseavvik med obligatorisk kommentar har en kommentar
            </CheckmarkText>
          </CheckmarkLabel>
        )}
      </Notice>

      {healthRemarkGroupToDelete && (
        <Modal>
          <Label
            size="1.15em"
            padding="1.5em"
          >
            Er du sikker på å slette
            denne gruppen?
          </Label>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              fontSize: '1.15em',
              justifyContent: 'center',
            }}
          >
            <ModalCancelButton
              onClick={() => setHealthRemarkGroupToDelete(null)}
            >
              Nei
            </ModalCancelButton>
            <ModalDangerousActionButton
              style={{
                marginLeft: '1em',
              }}
              onClick={() => {
                setHealthRemarkGroupToDelete(null);
                onDeleteHealthRemarkGroup(healthRemarkGroupToDelete.animalGroupIdx, healthRemarkGroupToDelete.healthRemarkGroupIdx);
              }}
            >
              Ja
            </ModalDangerousActionButton>
          </div>
        </Modal>
      )}

    </Wrapper>
  );
};
